import {useTranslation} from "react-i18next";

const useEventOptions = () => {

    //i18n
    const {t} = useTranslation("audit");

    return [
        LOGIN, LOGOUT,
        FORGOT_PASSWORD, FORGOT_PASSWORD_VALIDATE_TOKEN, FORGOT_PASSWORD_CHANGE,
        USER_ACTIVATION, SEND_WELCOME_EMAIL,
        CHANGE_PASSWORD,
        CREATE_USER, UPDATE_USER, CHANGE_USER_PASSWORD, UPDATE_USER_STATUS, DELETE_USER,
        CREATE_CLIENT, UPDATE_CLIENT, UPDATE_CLIENT_STATUS, DELETE_CLIENT,
        FETCH_INVOICES, DOWNLOAD_INVOICE,
        FETCH_DELIVERY_NOTES, DOWNLOAD_DELIVERY_NOTE, DOWNLOAD_PACKING_LIST,
        DOWNLOAD_STOCK,
        STOCKS_SERVICE,
        FETCH_TECHNICAL_SHEETS, DOWNLOAD_TECHNICAL_SHEET,
    ].map(event => {
        return {
            value: event,
            label: t(`eventOptions.${event}`)
        }
    });
};

// Events
const LOGIN = "LOGIN";
const LOGOUT = "LOGOUT";

const FORGOT_PASSWORD = "FORGOT_PASSWORD";
const FORGOT_PASSWORD_VALIDATE_TOKEN = "FORGOT_PASSWORD_VALIDATE_TOKEN";
const FORGOT_PASSWORD_CHANGE = "FORGOT_PASSWORD_CHANGE";

const USER_ACTIVATION = "USER_ACTIVATION";
const SEND_WELCOME_EMAIL = "SEND_WELCOME_EMAIL";

const CHANGE_PASSWORD = "CHANGE_PASSWORD";

const CREATE_USER = "CREATE_USER";
const UPDATE_USER = "UPDATE_USER";
const CHANGE_USER_PASSWORD = "CHANGE_USER_PASSWORD";
const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";
const DELETE_USER = "DELETE_USER";

const CREATE_CLIENT = "CREATE_CLIENT";
const UPDATE_CLIENT = "UPDATE_CLIENT";
const UPDATE_CLIENT_STATUS = "UPDATE_CLIENT_STATUS";
const DELETE_CLIENT = "DELETE_CLIENT";

const FETCH_INVOICES = "FETCH_INVOICES";
const DOWNLOAD_INVOICE = "DOWNLOAD_INVOICE";

const FETCH_DELIVERY_NOTES = "FETCH_DELIVERY_NOTES";
const DOWNLOAD_DELIVERY_NOTE = "DOWNLOAD_DELIVERY_NOTE";
const DOWNLOAD_PACKING_LIST = "DOWNLOAD_PACKING_LIST";

const DOWNLOAD_STOCK = "DOWNLOAD_STOCK";

const STOCKS_SERVICE = "stocks_service";

const FETCH_TECHNICAL_SHEETS = "FETCH_TECHNICAL_SHEETS";
const DOWNLOAD_TECHNICAL_SHEET = "DOWNLOAD_TECHNICAL_SHEET";

export {
    useEventOptions,
    LOGIN, LOGOUT,
    FORGOT_PASSWORD, FORGOT_PASSWORD_VALIDATE_TOKEN, FORGOT_PASSWORD_CHANGE,
    USER_ACTIVATION, SEND_WELCOME_EMAIL,
    CHANGE_PASSWORD,
    CREATE_USER, UPDATE_USER, CHANGE_USER_PASSWORD, UPDATE_USER_STATUS, DELETE_USER,
    CREATE_CLIENT, UPDATE_CLIENT, UPDATE_CLIENT_STATUS, DELETE_CLIENT,
    FETCH_INVOICES, DOWNLOAD_INVOICE,
    FETCH_DELIVERY_NOTES, DOWNLOAD_DELIVERY_NOTE, DOWNLOAD_PACKING_LIST,
    DOWNLOAD_STOCK,
    STOCKS_SERVICE,
    FETCH_TECHNICAL_SHEETS, DOWNLOAD_TECHNICAL_SHEET
}